module.exports = __webpack_public_path__ + "img/coming.d1b5289d.png";